import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-import-icon',
  imports: [],
  templateUrl: './import-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './import-icon.component.scss',
})
export class ImportIconComponent {}
